import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { fetchCmsMetaData } from "../../../../Components/Utility/cmsMetaService";
import { SetMetaTags } from "../../../../Components/Utility/setMetaTags";

function HostCurrency() {
  const navigate = useNavigate();
  const savedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || {};
    } catch {
      return {};
    }
  })();

  const [currencyId, setCurrencyId] = useState(savedUser?.currency_id || "");
  const [currencyList, setCurrencyList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [meta, setMeta] = useState();

  // Fetch currencies
  useEffect(() => {
    const fetchCurrencies = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE}/getCurrency`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          },
        );
        setCurrencyList(res?.data?.data || res?.data || []);
      } catch (err) {
        console.error("GET /host/getCurrency error:", err);
        toast.error("Failed to load currency list ❌");
      } finally {
        setLoading(false);
      }
    };
    fetchCurrencies();
  }, []);

  // Cancel button
  const handleCancel = () => setCurrencyId(savedUser?.currency_id || "");

  // Save new currency
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!currencyId) {
      toast.error("Please choose a currency.");
      return;
    }

    try {
      setSaving(true);
      const res = await toast.promise(
        axios.post(
          `${process.env.REACT_APP_API_BASE}/host/update-currency`,
          { currency_id: Number(currencyId) },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          },
        ),
        {
          loading: "Saving currency…",
          success: "Currency updated ✅",
          error: "Failed to update currency ❌",
        },
      );

      // ✅ FIX: Update localStorage user object
      const updatedUser = { ...savedUser, currency_id: Number(currencyId) };
      localStorage.setItem("user", JSON.stringify(updatedUser));

      // ✅ Update state so UI stays consistent
      setCurrencyId(Number(currencyId));
    } catch (err) {
      console.error("POST /host/update-currency error:", err);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    const loadMeta = async () => {
      const data = await fetchCmsMetaData("currency");
      setMeta(data);
    };

    loadMeta();
  }, []);
  return (
    <section className="mng_bottomss user_allls profiles all_titless myprofiless">
      <SetMetaTags
        title={meta?.meta_title || "Currency | Weyfarin"}
        description={meta?.meta_description || "Currency | Weyfarin"}
      />

      <div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
        <div className="row">
          <div className="col-lg-8">
            <div className="discriptionns">
              <h3>Currency</h3>
            </div>

            <div className="form_al_fildss">
              <div className="ac_stest">
                <h3>
                  Preferred Currency
                  <span className="ar_rights">
                    <button
                      type="button"
                      value="cancel"
                      onClick={handleCancel}
                      disabled={saving}
                    >
                      Cancel
                    </button>
                  </span>
                </h3>
              </div>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label>Choose Currency</label>
                      <select
                        className="form-control"
                        name="currency_id"
                        value={currencyId}
                        onChange={(e) => setCurrencyId(e.target.value)}
                        disabled={loading || saving}
                      >
                        <option value="">
                          {loading ? "Loading currencies…" : "Select currency"}
                        </option>
                        {currencyList.map((c) => (
                          <option key={c.id} value={c.id}>
                            {c.country_name} {c.code ? `(${c.code})` : ""}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="submmit">
                      <button type="submit" value="save" disabled={saving}>
                        {saving ? "Saving…" : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HostCurrency;
